/**
* @summary - Component that Provides PPM TracK Calender functionality
* @autor vengateshwaran k
* @since 2024-05-30
*/
import { Box } from "@mui/material";
import { format } from 'date-fns';
const SquareBoxRenderer = (props) => {
  const { value } = props; // value now contains { date, color }

  if (!value) return null;

  const { date, color } = value;

  return (
    <Box
      sx={{
        width: 50, // adjust width of the box as needed
        height: 50, // adjust height of the box as needed
       // backgroundColor: color, // dynamic background color
        backgroundImage:color,  // gradient background color
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white', // text color, adjust as needed
        fontSize: '15px', // text size, adjust as needed
      }}
      title={format(date, 'dd MMM, yyyy')} // Show full date on hover
    >
      {format(date, 'dd')} {/* Show only the day part of the date */}
    </Box>
  );
};

export default SquareBoxRenderer;
